// extracted by mini-css-extract-plugin
export default {"logoWrapper":"styles_logoWrapper__1TgpR"};